<div class="quote-price-checklist">
  <h5 class="quote-price-checklist__label">{{ label }}</h5>
  <lx-key-point
    *ngFor="let keypoint of keyPoints"
    [icon]="icon"
    [text]="keypoint.description"
    [additionalText]="keypoint.additionalDescription"
    [price]="keypoint.price | lxPrice : { currency: currency, minDecimalPlaces: decimalPlaces }"
  ></lx-key-point>
</div>
